import * as actionTypes from './actionTypes'

export const fetchRecentGrant = (payload) => ({
  type: actionTypes.fetchRecentGrantType,
  payload,
});

export const charitySearched = (payload) => ({
  type: actionTypes.postCharitySearchType,
  payload,
});

export const citySearched = (payload) => ({
  type: actionTypes.postCitySearchType,
  payload,
});

export const countySearched = (payload) => ({
  type: actionTypes.postCountrySearchType,
  payload,
});

export const cityLoader = (payload) => ({
  type: actionTypes.cityLoaderType,
  payload,
});

export const countyLoader = payload => ({
  type: actionTypes.countryLoaderType,
  payload
});

export const selectCharity = (payload) => ({
  type: actionTypes.selectCharityType,
  payload,
});

export const changeScheduleAllocation = (payload) => ({
  type: actionTypes.changeScheduleAllocationType,
  payload,
});

export const changeNoOfPayments = (payload) => ({
  type: actionTypes.changeNumberOfPaymentsType,
  payload,
});

export const showGeminiFilter = (payload) => ({
  type: actionTypes.geminiFilterType,
  payload,
});

export const updateFromCounter = (payload) => ({
  type: actionTypes.updateFromCounterType,
  payload,
});

export const updateLoadMoreCounter = (payload) => ({
  type: actionTypes.updateFromLoadingCounterType,
  payload,
});

export const clearPaymentDetails = (payload) => ({
  type: actionTypes.clearPaymentDetailsType,
  payload,
});

export const receiveAllocationTableData = (payload) => ({
  type: actionTypes.receiveAllocationDataType,
  payload,
});

export const fetchGrantHistory = (payload) => ({
  type: actionTypes.fetchGrantHistoryType,
  payload,
});

export const fetchPendingGrant = (payload) => ({
  type: actionTypes.fetchPendingGrantType,
  payload,
});

export const updateFrom = () => ({
  type: actionTypes.updateFromType,
});

export const einData = (payload) => ({
  type: actionTypes.einDataType,
  payload,
});

export const geminiEinData = (payload) => ({
  type: actionTypes.geminiEinDataType,
  payload,
});

export const SearchTerm = (payload) => ({
  type: actionTypes.searchTermType,
  payload,
});

export const GeminiSearchTerm = (payload) => ({
  type: actionTypes.geminiSearchTermType,
  payload,
});

export const searchGemini = (payload) => ({
  type: actionTypes.searchGeminiType,
  payload,
});

export const fetchGrantPurposeConfig = (payload) => ({
  type: actionTypes.fetchGrantPurposeType,
  payload,
});

export const changePurposeRecognition = (payload) => ({
  type: actionTypes.changePurposeRecognitionType,
  payload,
});

export const removeCharity = (payload, successFn) => ({
  type: actionTypes.removeCharityType,
  payload,
  successFn,
});

export const fetchSavedCharity = (payload) => ({
  type: actionTypes.fetchSavedCharityType,
  payload,
});

export const postSavedCharity = (payload, successFn) => ({
  type: actionTypes.saveCharityType,
  payload,
  successFn,
});

export const postSavedGemini = (payload, successFn) => ({
  type: actionTypes.postGeminiSavedDataType,
  payload,
  successFn,
});

export const submitGrantRequest = (payload, successFn) => ({
  type: actionTypes.submitGrantType,
  payload,
  successFn,
});

export const cancelGrantFlow = (payload) => ({
  type: actionTypes.cancelFlowType,
  payload,
});

export const grantDetailsLoader = (payload) => ({
  type: actionTypes.grantDetailsLoaderType,
  payload,
});

export const enableEdit = (payload) => ({
  type: actionTypes.enableEditType,
  payload,
});

export const resetEdit = (payload) => ({
  type: actionTypes.resetEditType,
  payload,
});

export const updateGrant = (payload, successFn) => ({
  type: actionTypes.updateGrantType,
  payload,
  successFn,
});

export const clearUpdateErrors = (payload, successFn) => ({
  type: actionTypes.updateClearErrorsType,
  payload,
  successFn,
});

export const needUpdate = (payload) => ({
  type: actionTypes.needUpdateType,
  payload,
});

export const changeScheduleId = (payload) => ({
  type: actionTypes.scheduleIdType,
  payload,
});

export const cancelSchedule = (payload) => ({
  type: actionTypes.cancelScheduleType,
  payload,
});

export const cancelAllSchedules = (payload) => ({
  type: actionTypes.cancelAllSchedulesType,
  payload,
});

export const addSpawn = (payload) => ({
  type: actionTypes.addSpawnType,
  payload,
});

export const updateIndividualSpawn = (payload) => ({
  type: actionTypes.updateIndividualSpawnType,
  payload,
});

export const newGrant = (payload) => ({
  type: actionTypes.newFlowType,
  payload,
});

export const enableRegrant = (payload) => ({
  type: actionTypes.reGrantType,
  payload,
});

export const clearAllFilter = (payload) => ({
  type: actionTypes.clearAllFilterType,
  payload,
});

export const clearAllGeminiFilter = (payload) => ({
  type: actionTypes.clearAllGeminiFilterType,
  payload,
});

// action to fetch both pending pools and admin fee
export const fetchPoolsPendingAdminFee = (payload, successFn) => ({
  type: actionTypes.poolsPendingAdminFeeType,
  payload,
  successFn,
});

export const addCharity = (payload, selectedCharity, successFn) => ({
  type: actionTypes.addCharityType,
  payload,
  selectedCharity,
  successFn,
});

export const cancelSaveCharity = (payload) => ({
  type: actionTypes.cancelSaveCharityType,
  payload,
});

export const exhaustCheck = (payload) => ({
  type: actionTypes.exhaustCheckType,
  payload,
});

export const pageScroll = (payload) => ({
  type: actionTypes.pageScrollType,
  payload,
});
export const projectName = (payload) => ({
  type: actionTypes.addProjectNameType,
  payload,
});
export const addPurpose = (payload) => ({
  type: actionTypes.addPurposeType,
  payload,
});
export const addEventName = (payload) => ({
  type: actionTypes.addEventNameType,
  payload,
});
export const addMissionaryName = (payload) => ({
  type: actionTypes.addMissionaryNameType,
  payload,
});
export const addMissionaryLocation = (payload) => ({
  type: actionTypes.addMissionaryLocationType,
  payload,
});

export const resetSavedCharityLoadingFlag = () => ({
  type: actionTypes.savedCharityFlagType,
  payload: true,
});
